export const ROUTE_ENDPOINTS = {
  LANDING: "/",
  HOME: "/home/*",
  GAME: "/game",
  GAME_FINISHED: "/game_finished",
  HOME_PLAY: "/home/play",
  HOME_UNFINISHED_GAMES: "/home/unfinished_games",
  HOME_DASHBOARD: "/home/dashboard",
  DASHBOARD: "/dashboard",
  UNFINISHED_GAMES: "/unfinished_games",
  PLAY: "/play",
};

export const ROUTE_NEW = "new";
